import { get } from '.';

export function GetCampaignCommunicationTransactions(options = {}) {
	return get<any>("/app/api/campaign_communication_transactions", options);
}

export function GetConferenceCampaignCommunicationTransactions(conferenceVid, options = {}) {
	return get<any>("/app/api/conferences/" + conferenceVid + "/campaign_communication_transactions", options);
}
